// import $ from 'jquery';
import React from 'react'
import PropTypes from 'prop-types'
// import { omit } from 'lodash';
import { equals, isEmpty, isPostalCode } from 'validator'

// OPTIMIZE: create FORM around fields to allow enter trigger
// OPTIMIZE: liveValidation flag to allow validation onBlur/as we go
// OPTIMIZE: custom messages for different validations (user validate.js)
class Field extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      displayError: false,
      hasError: false,
      hasSuccess: false,
      isFocused: false,
      isFilled: !isEmpty(String(this.props.value)),
    }
  }
  // OPTIMIZE: use getSnapshotBeforeUpdate
  componentDidUpdate(prevProps, prevState) {
    this.lastValue = this.props.value
    // const propsN = omit(this.props, 'children');
    // const prevPropsN = omit(prevProps, 'children');

    // console.log(this.input, propsN.checked, prevPropsN.checked);
    // check any changes to the props/state
    // if ((JSON.stringify(propsN) !== JSON.stringify(prevPropsN) || JSON.stringify(this.state) !== JSON.stringify(prevState))) {
    if (prevProps.value !== this.props.value) {
      this.setState(this.getClassesState())
    }
  }
  getErrorClassesState() {
    const valid = this.validate()
    const isFilled = this.validateEmpty()

    return {
      hasSuccess: valid && isFilled ? true : false,
      hasError: !valid && isFilled ? true : false,
      displayError: valid ? false : this.state.displayError,
    }
  }

  getClassesState() {
    const { required } = this.props
    let newState = {
      isFilled: this.validateEmpty(),
    }

    if (required) {
      newState = {
        ...newState,
        ...this.getErrorClassesState(),
      }
    }
    return newState
  }

  // `generateProps` handles what are the essential props to be passed down to the extended component
  generateProps() {
    const { name, value, readOnly, disabled, placeholder, autoComplete, required, minLength, maxLength } = this.props
    return {
      name: name,
      value: value,
      readOnly: readOnly,
      disabled: disabled,
      placeholder: placeholder,
      autoComplete: autoComplete,
      required: required,
      minLength: minLength,
      maxLength: maxLength,
      onKeyDown: (e) => this.onKeyDown(e),
      onKeyPress: (e) => this.onKeyPress(e),
      onChange: (e) => this.onChange(e),
      onClick: (e) => this.onClick(e),
      onFocus: (e) => this.onFocus(e),
      onBlur: (e) => this.onBlur(e),
    }
  }

  // `handleClasses` handles all the default classes that can be used to changed the fields style
  handleClasses() {
    const { className, checked, inline, big, isDisabled, disableSuccess = false, hasIframeClass } = this.props
    const { isFocused, isFilled, hasError, hasSuccess } = this.state
    let classes = 'field'

    if (inline) {
      classes = classes.concat(' field--inline')
    }
    if (checked) {
      classes = classes.concat(' field--checked')
    }
    if (big) {
      classes = classes.concat(' field--big')
    }
    if (hasError) {
      classes = classes.concat(' field--alert')
    }
    if (hasSuccess && disableSuccess === false) {
      classes = classes.concat(' field--success')
    }
    if (isFocused) {
      classes = classes.concat(' field--focus')
    }
    if (isFilled) {
      classes = classes.concat(' field--filled')
    }
    if (isDisabled) {
      classes = classes.concat(' field--disabled')
    }
    if (className) {
      classes = classes.concat(` ${className}`)
    }

    return classes
  }
  // validations
  // `validate` will always be triggered on the componentDidUpdate so that we can check if the latest value is valid

  validateExtraConditions() {
    const { value, identical, validate } = this.props
    let extraConditions = true

    // identical prop
    if (identical) {
      extraConditions = extraConditions && equals(String(value), String(identical))
    }

    if (validate === 'postcode') {
      extraConditions = extraConditions && isPostalCode(String(value), 'AU')
    }

    return extraConditions
  }

  validateEmpty() {
    const { value, required } = this.props

    if (required) {
      return !isEmpty(String(value))
    }

    return true
  }

  validate() {
    const extraConditions = this.validateExtraConditions()

    return this.validateEmpty() && extraConditions
  }
  // `format` will always be triggered BEFORE any value is updated, so that it can be changed to fit any conditions
  format(value) {
    return value
  }
  // events
  onKeyDown(e) {
    // saves the last character as 'false' for cases like input type=number, which doesn't trigger the onChange
    this.lastInput = false
  }
  onKeyPress(e) {
    // saves the last character typed
    const charCode = e.which || e.keyCode
    const charStr = String.fromCharCode(charCode)
    this.lastInput = charStr
  }
  onChange(e) {
    const { onChange } = this.props
    const { value } = e.target
    const formattedValue = this.format(value)

    // SET_STATE
    if (onChange) {
      onChange(e, formattedValue)
    }
  }
  onClick(e) {
    const { onClick } = this.props

    // SET_STATE
    if (onClick) {
      onClick(e)
    }
  }
  onFocus(e) {
    const { onFocus, readOnly } = this.props
    if (readOnly) return

    if (onFocus) {
      onFocus(e)
    }

    this.setState({
      isFocused: true,
    })
  }

  onBlur(e) {
    // const { hasError } = this.state;
    const { onBlur } = this.props

    if (onBlur) {
      onBlur(e)
    }

    this.setState({
      isFocused: false,
      // displayError: hasError
    })
  }

  // render
  renderError() {
    const { alertMessage } = this.props
    const { displayError } = this.state
    if (!displayError) return null
    return <span className="field__alert fadeIn animated">{alertMessage}</span>
  }

  renderLabel() {
    const { label, hasIframeClass = false, sholdFocusInput = false } = this.props
    if (!label) return null

    return (
      <span
        className={'field__text ' + (hasIframeClass === true ? 'field__text--iframe' : '')}
        onClick={() => sholdFocusInput && this.input.focus()}
      >
        {label}
      </span>
    )
  }

  renderValue() {
    const { label } = this.props
    if (!label) return null

    // could have html link in label
    return <span className="field__value" dangerouslySetInnerHTML={{ __html: label }} />
  }

  renderAutoresize() {
    const { value, placeholder, autoResize } = this.props
    if (!autoResize) return null
    return <div className="field__input field__input--autoresize">{value !== '' ? value : placeholder}</div>
  }

  render() {
    const { animatedLabel, type = 'text' } = this.props

    return (
      <div className={this.handleClasses()} data-label={animatedLabel} ref={(r) => (this.field = r)}>
        {this.renderLabel()}
        {this.renderAutoresize()}
        <input className="field__input" ref={(r) => (this.input = r)} {...this.generateProps()} type={type} />
        {this.renderError()}
      </div>
    )
  }
}

// default props
Field.defaultProps = {
  label: undefined,
  animatedLabel: undefined,
  autoComplete: 'on',
  // type: 'text',
  name: 'field',
  value: '',
  placeholder: undefined,
  identical: undefined,
  step: 1,
  min: undefined,
  max: undefined,
  big: false,
  required: false,
  checked: undefined,
  readOnly: false,
  disabled: false,
  autoResize: false,
  hasIframeClass: false,
  disableSuccess: false,
  alertMessage: 'This field is required.',
  // onChange: () => {},
}
// validate props
Field.propTypes = {
  // label: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  animatedLabel: PropTypes.string,
  autoComplete: PropTypes.string,
  // type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  placeholder: PropTypes.string,
  identical: PropTypes.any,
  step: PropTypes.number,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  big: PropTypes.bool,
  required: PropTypes.bool,
  checked: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  autoResize: PropTypes.bool,
  hasIframeClass: PropTypes.bool,
  disableSuccess: PropTypes.bool,
  alertMessage: PropTypes.string,
  // onChange: PropTypes.func.isRequired,
}

export default Field
